import React from 'react';
import Img from '@/images';
import withBreakpoints from '@/hocs/withBreakpoints';
import styles from './styles.module.scss';

const FaqRightShape = withBreakpoints({
  desktop: props => (
    <div className={styles['faq-right-shapes']}>
      <Img
        src="/static/images/hris/employee-onboarding/faq-shapes.svg"
        alt="Workable shapes graphic"
      />
    </div>
  )
});

export default FaqRightShape;
